module.exports = __webpack_public_path__ + "img/logo_por.836f684d.svg";